var Base = require('_js/base'),
  ko = require('knockout'),
  hashHelper = require('_js/utils/hash-helper');

function getYearList() {
  var currentYear = new Date().getFullYear();
  var previousYearsToShow = 4;

  var years = [];
  for (var x = currentYear; x >= currentYear - previousYearsToShow; x--) {
    years.push(x);
  }
  return years;
}

var Model = function(params) {
  var self = this;
  var selects;

  if (params.categoryList === undefined) throw 'categoryList must be set';

  var filterTopic = params.filterTopic || 'articleSearchFilterTopic';
  var hasher = new hashHelper(filterTopic);
  self.categoryList = ko.observableArray(params.categoryList);

  self.currentRelevanceSorting = ko.observable(false);
  self.categoryList = params.categoryList;
  self.yearList = [window.language.showAll].concat(getYearList());
  self.activeQuery = hasher.getListener(hasher.validHashes.searchTerm, '');
  self.year = hasher.getListener(hasher.validHashes.year);
  self.type = hasher.getListener(hasher.validHashes.type);
  self.category = hasher.getListener(hasher.validHashes.category);

  self.query = ko.observable(self.activeQuery());
  self.search = function() {
    self.activeQuery($('#search').val());
  };

  self.resetFilters = function() {
    self.query(undefined);
    self.search();

    if (selects) {
      // Since we're using the selectize plugin we have to
      // modify these values instead of the observables.
      // By changing these values, however, the observables
      // will be changed.
      // selects[0].selectize.setValue(-1);                      // category
      selects[0].selectize.setValue(window.language.showAll); // year
      selects[1].selectize.setValue(-1); // type
    }

    ko.postbox.publish('clearArticleFilters');
  };

  // Update the normal selects to the plugin selects (but this should be called after ko has rendered the vanilla selects).
  self.doSelectize = function() {
    if (selects === undefined) {
      selects = $('.form-select-wrapper-special').selectize();
    }
  };

  self.currentRelevanceSortingClick = function(relevanceSort) {
    self.currentRelevanceSorting(relevanceSort);
    ko.postbox.publish('currentRelevanceSorting', relevanceSort);
  };

  self.categoriesChecked = function(checkedCategories) {
    self.category(checkedCategories.toString());
  };
};

function ArticleSearch() {
  this.init();
}

ArticleSearch.prototype = new Base();

ArticleSearch.prototype.init = function() {
  $('[data-article-search]').each(function() {
    ko.applyBindings(new Model($(this).data('article-search')), this);
  });
};

module.exports = ArticleSearch;
